import { render } from "./RecipientPage.vue?vue&type=template&id=6b8c56ed&scoped=true"
import script from "./RecipientPage.vue?vue&type=script&lang=js"
export * from "./RecipientPage.vue?vue&type=script&lang=js"

import "./RecipientPage.vue?vue&type=style&index=0&id=6b8c56ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8c56ed"]])

export default __exports__